import React from 'react';
import { JuniorLayout } from '../components/layout/JuniorLayout';
import { JuniorAliveZone } from '../components/layout/JuniorAliveZone';
import { JuniorHomeHero } from '../components/home/JuniorHomeHero';
import { JuniorMenuCards } from '../components/home/JuniorMenuCards';
import { RequireJuniorSession } from '../components/auth/RequireJuniorSession';
import { usePlaySession } from '@/play/contexts/PlaySessionContext';
import { useJuniorAliveNav } from '../contexts/JuniorAliveNavContext';
import { MENU_ITEMS } from '../lib/juniorTheme';

function HomePageInner() {
  const { userName } = usePlaySession();
  const { animateEntry } = useJuniorAliveNav();

  return (
    <JuniorLayout>
      <JuniorAliveZone className="mx-auto max-w-7xl px-4 sm:px-8 py-8 sm:py-12 pb-20" accent="coral">
        <div className={animateEntry ? 'junior-alive-block' : undefined}>
          <JuniorHomeHero userName={userName} animateEntry={animateEntry} />
        </div>
        <JuniorMenuCards items={MENU_ITEMS} animateEntry={animateEntry} />
      </JuniorAliveZone>
    </JuniorLayout>
  );
}

export default function HomePage() {
  return (
    <RequireJuniorSession>
      <HomePageInner />
    </RequireJuniorSession>
  );
}
